import React, { useState } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import { decodeAccount } from '../utils/utils';
import DialogForm from './DialogForm';
// import { Select, MenuItem, FormHelperText, FormControl, InputLabel, Chip } from '@material-ui/core';



import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { MenuProps, useStyles, } from "../utils/Styles"



export default function DistributeBalanceDialog({ open, onAdd, onClose }) {
    const [amount, setAmount] = useState('');
    const [isImport, setIsImport] = useState(true);
    const [importedPrivateKey, setPrivateKey] = useState('');
    var tempArray = []
    var option = JSON.parse(localStorage.getItem("all_account_key"))
    for (let i = 0; i < option.length; i++) {
        tempArray.push({
            address: option[i].address,
            index: option[i].index
        })
    }
    var options = tempArray
    // options=tempArray


    // console.log("record", tempArray);



    const classes = useStyles();
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState("");
    const isAllSelected = options.length > 0 && selected.length === options.length;

    const handleChange = (event) => {
        const value = event.target.value;
        console.log("value=>>>>", value)
        if (value[value.length - 1] === "all") {
            setSelected(selected.length === options.length ? [] : options);
            return;
        }
        setSelected(value);


    };
    // console.log("imran>>>>>>>>>>>>>>", options.filter(n => !selected.includes(n.address)))


    var remainingWallet = options.filter(n => !selected.includes(n.address))
    const handleChangeSingleValue = (event) => {
        const value = event.target.value;
        // if (value[value.length - 1] === "all") {
        //   setSelected1(selected1.length === remainingWallet.length ? [] : remainingWallet);
        //   return;
        // }
        setSelected1(value);


    };






    // const [selected, setSelected] = useState([]);



    const [wallet_value, setWallet_Value] = useState("SeCbhUgwfifKUVc3Ut5Z7hRCRMsPyFr1Z4hyargXYYv")

    const selectionChangeHandler = (event) => {
        setSelected(event.target.value);
    };
    const selectionChangeHandler1 = (event) => {
        setSelected(event.target.value);
    };

    const importedAccount = isImport
        ? decodeAccount(importedPrivateKey)
        : undefined;
    // const isAddEnabled = isImport ? name && importedAccount !== undefined : false;


    // console.log("isAddEnabled",isAddEnabled);

   
    return (
        <DialogForm
            open={open}
            onEnter={() => {
                setAmount('');
                setIsImport(true);
                setPrivateKey('');
            }}
            onClose={onClose}
            onSubmit={() => onAdd({ selected, selected1,amount })}
            fullWidth
        >
            <DialogTitle>Distribute Balance</DialogTitle>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginRight:15,
                    marginLeft:15
                }}
            >
                <TextField 
                    label="Amount"
                    fullWidth
                    variant="outlined"
                    type="Number"
                    margin="normal"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />

<FormControl >
                <InputLabel id="mutiple-select-label">From</InputLabel>
                <Select
                    labelId="mutiple-select-label"
                    // multiple
                    value={selected1}
                    onChange={handleChangeSingleValue}
                    // renderValue={(selected1) => selected1.join(", ")}
                    MenuProps={MenuProps}
                >
                    <MenuItem
            value="all"
            classes={{
              root: isAllSelected ? classes.selectedAll : ""
            }}
          >
                    <ListItemIcon>
              <Checkbox
                classes={{ indeterminate: classes.indeterminateColor }}
                checked={isAllSelected}
                // indeterminate={
                //   selected.length > 0 && selected.length < options.length
                // }
              />
            </ListItemIcon>
                    <ListItemText
              classes={{ primary: classes.selectAllText }}
              primary="Select All"
            />
          </MenuItem>
                    {remainingWallet.map((option) => (
                        <MenuItem key={option} value={option.address}>
                            <ListItemIcon>
                                <Checkbox checked={selected1.indexOf(option.address) > -1} />
                            </ListItemIcon>
                            <ListItemText primary={option.address} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl >
                <InputLabel id="mutiple-select-label" style={{ marginTop: 5, fontSize: 20, marginBottom: 10 }}>To</InputLabel>
                <Select
                    labelId="mutiple-select-label"
                    multiple
                    value={selected}
                    onChange={handleChange}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                >
                    <MenuItem
                        value="all"
                        classes={{
                            root: isAllSelected ? classes.selectedAll : ""
                        }}
                    >
                        <ListItemIcon>
                            <Checkbox
                                classes={{ indeterminate: classes.indeterminateColor }}
                                checked={isAllSelected}
                                indeterminate={
                                    selected.length > 0 && selected.length < options.length
                                }
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.selectAllText }}
                            primary="Select All"
                        />
                    </MenuItem>
                    {options.map((option) => (
                        <MenuItem key={option.index} value={option.address}>
                            <ListItemIcon>
                                <Checkbox checked={selected.indexOf(option.address) > -1} />
                            </ListItemIcon>
                            <ListItemText primary={option.address} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            </div>


            
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
                <Button type="submit" color="primary" >
                    Send
                </Button>
            </DialogActions>
        </DialogForm>
    );
}
